import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { Send, Building2, Users, Globe } from 'lucide-react';
export function ContactSalesPage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      navigate('/thank-you');
    }, 1000);
  };
  return <div className="min-h-screen bg-background text-textMain py-12 px-6" data-id="element-5957">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-5958">
        {/* Left: Value Prop */}
        <div className="flex flex-col justify-center" data-id="element-5959">
          <Link to="/" className="flex items-center gap-2 mb-12" data-id="element-5960">
            <span className="text-2xl font-bold tracking-tight" data-id="element-5961">Booker</span>
            <div className="w-2 h-2 rounded-full bg-primary mt-1" data-id="element-5962"></div>
          </Link>

          <h1 className="text-4xl font-bold mb-6" data-id="element-5963">Talk to our sales team</h1>
          <p className="text-lg text-textMuted mb-12 leading-relaxed" data-id="element-5964">
            Whether you're managing a multi-room venue, running a boutique
            agency, or booking a national tour, we can help you set up Booker
            for your specific workflow.
          </p>

          <div className="space-y-8" data-id="element-5965">
            <div className="flex items-start gap-4" data-id="element-5966">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary shrink-0" data-id="element-5967">
                <Building2 className="w-6 h-6" data-id="element-5968" />
              </div>
              <div data-id="element-5969">
                <h3 className="font-bold text-lg mb-1" data-id="element-5970">Custom Onboarding</h3>
                <p className="text-sm text-textMuted" data-id="element-5971">
                  We'll help migrate your historical data, contacts, and
                  templates.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-5972">
              <div className="w-12 h-12 rounded-xl bg-blue-500/10 flex items-center justify-center text-blue-500 shrink-0" data-id="element-5973">
                <Users className="w-6 h-6" data-id="element-5974" />
              </div>
              <div data-id="element-5975">
                <h3 className="font-bold text-lg mb-1" data-id="element-5976">Team Training</h3>
                <p className="text-sm text-textMuted" data-id="element-5977">
                  Dedicated sessions for your agents, promoters, and ops teams.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-5978">
              <div className="w-12 h-12 rounded-xl bg-green-500/10 flex items-center justify-center text-green-500 shrink-0" data-id="element-5979">
                <Globe className="w-6 h-6" data-id="element-5980" />
              </div>
              <div data-id="element-5981">
                <h3 className="font-bold text-lg mb-1" data-id="element-5982">Enterprise Support</h3>
                <p className="text-sm text-textMuted" data-id="element-5983">
                  Priority SLA, custom integrations, and dedicated account
                  management.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right: Form */}
        <div className="bg-surface border border-border rounded-2xl p-8" data-id="element-5984">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-5985">
            <div className="grid grid-cols-2 gap-6" data-id="element-5986">
              <div data-id="element-5987">
                <label className="block text-sm font-medium mb-2" data-id="element-5988">
                  First Name *
                </label>
                <input required type="text" className="w-full px-4 py-3 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-5989" />
              </div>
              <div data-id="element-5990">
                <label className="block text-sm font-medium mb-2" data-id="element-5991">
                  Last Name *
                </label>
                <input required type="text" className="w-full px-4 py-3 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-5992" />
              </div>
            </div>

            <div data-id="element-5993">
              <label className="block text-sm font-medium mb-2" data-id="element-5994">
                Work Email *
              </label>
              <input required type="email" className="w-full px-4 py-3 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-5995" />
            </div>

            <div data-id="element-5996">
              <label className="block text-sm font-medium mb-2" data-id="element-5997">
                Company / Organization *
              </label>
              <input required type="text" className="w-full px-4 py-3 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-5998" />
            </div>

            <div className="grid grid-cols-2 gap-6" data-id="element-5999">
              <div data-id="element-6000">
                <label className="block text-sm font-medium mb-2" data-id="element-6001">
                  Role Type *
                </label>
                <select required className="w-full px-4 py-3 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-6002">
                  <option value="" data-id="element-6003">Select...</option>
                  <option data-id="element-6004">Venue / Promoter</option>
                  <option data-id="element-6005">Agent / Manager</option>
                  <option data-id="element-6006">Artist / Band</option>
                  <option data-id="element-6007">Other</option>
                </select>
              </div>
              <div data-id="element-6008">
                <label className="block text-sm font-medium mb-2" data-id="element-6009">
                  Team Size
                </label>
                <select className="w-full px-4 py-3 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-6010">
                  <option data-id="element-6011">1-5</option>
                  <option data-id="element-6012">6-20</option>
                  <option data-id="element-6013">21-50</option>
                  <option data-id="element-6014">50+</option>
                </select>
              </div>
            </div>

            <div data-id="element-6015">
              <label className="block text-sm font-medium mb-2" data-id="element-6016">
                How can we help?
              </label>
              <textarea rows={4} className="w-full px-4 py-3 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary resize-none" data-id="element-6017"></textarea>
            </div>

            <button type="submit" disabled={isSubmitting} className="w-full py-4 bg-primary text-background rounded-xl font-medium hover:bg-primaryHover transition-colors flex items-center justify-center gap-2 disabled:opacity-70 text-lg" data-id="element-6018">
              {isSubmitting ? 'Sending...' : <>
                  <Send className="w-5 h-5" data-id="element-6019" /> Contact Sales
                </>}
            </button>
          </form>
        </div>
      </motion.div>
    </div>;
}